/**
 * Created by tofaelraju on 3/25/17.
 */

import React from 'react';
import {connect} from 'react-redux';

import api from '../utility/api';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';

class ConsumerDetails extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      user: null,
      patients: []
    };
  }

  componentDidMount() {
    this.getUserPatients();
  }

  getUserPatients(){
    this.props.dispatch(asyncStart());
    api.getUserPatients()
      .then(resp => {
        this.props.dispatch(asyncEnd());
        this.setState({doctors: resp});
      })
      .catch(error => {
        this.props.dispatch(asyncEnd());
        this.props.dispatch(showFeedback({message: error.message}));
      });
  }

  render() {
    return (
      <div>Hello</div>
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(ConsumerDetails);


// WEBPACK FOOTER //
// ./src/containers/consumer-details.js